module.exports = __webpack_public_path__ + "img/doctor.ca68cf53.jpeg";